import {
  onUnmounted, computed, ref, watch,
} from '@vue/composition-api'
import GeozoneMap from '@/components/GeozoneMap/GeozoneMap'
import loadYmaps from '@/services/ymapsApi'
import LocationSearch from '@/components/LocationSearch/LocationSearch'
import { eventBus } from '@/components/Map/EventBus'


export default {
  props: {
    id: Number,
    search: Boolean,
    instancesList: Array,
  },
  components: { GeozoneMap, LocationSearch },
  name: 'GeozonesMap',
  setup(props, context) {
    const { $store } = context.root
    const geozones = computed(() => (props.id ? [$store.getters['geozone/geozone']] : $store.getters['geozones/list']))
    const geozoneInstances = ref([])
    const address = ref(null)
    const yMap = ref(null)
    let map = null
    let ymaps = null
    let geozoneLoaded = false

    const getHintLayout = (name, instancesCount) => `
      <div class='geozoneHint'>
          <span class="name">${name}</span><br/>
          Машин в геозоне: ${instancesCount}
      </div>`

    const filterInstances = () => {
      const array = []
      geozones.value.forEach(g => array.push(...g.instancesIds))
      geozoneInstances.value = [...new Set(array)]
    }

    const addGeozones = () => {
      if (!ymaps) return
      // todo разобраться с загрузкой яндекс апи
      if (!ymaps.templateLayoutFactory) return
      if (!geozones.value.length) return
      filterInstances()
      geozones.value.forEach((geozone) => {
        let newMapObj
        let marker

        const hintLayout = ymaps.templateLayoutFactory.createClass(getHintLayout(geozone.name || `Геозона №${geozone.id}`, geozone.instancesCount), {
          getShape() {
            const el = this.getElement()
            let result = null
            if (el) {
              const { firstChild } = el
              result = new ymaps.shape.Rectangle(
                new ymaps.geometry.pixel.Rectangle([
                  [0, 0],
                  [firstChild.offsetWidth, firstChild.offsetHeight],
                ]),
              )
            }
            return result
          },
        })

        const icon = {
          iconLayout: 'default#image',
          iconImageHref: require('@/assets/icons/point.svg'),
          iconImageSize: [25, 70],
          iconImageOffset: [-13, -45],
        }


        const { location } = geozone
        if (geozone.geozoneType === 'polygon') {
          newMapObj = new ymaps.Polygon(location.coords, {}, {
            editorDrawingCursor: 'crosshair',
            fillColor: '#F83333',
            fillOpacity: 0.2,
            strokeColor: '#F83333',
            strokeWidth: 2,
            hintLayout,
          })
          if (geozone.centroid.coordinates) {
            marker = new ymaps.Placemark(geozone.centroid.coordinates, {}, icon)
          }
        } else {
          // onj
          newMapObj = new ymaps.Circle([
            location.coords,
            location.radius,
          ], {}, {
            fillColor: '#27AE60',
            fillOpacity: 0.2,
            strokeColor: '#27AE60',
            // strokeOpacity: 0.8,
            strokeWidth: 2,
            hintLayout,
          })
          // placemark
          if (location.coords) {
            marker = new ymaps.Placemark(location.coords, {}, icon)
          }
        }

        if (marker) map.geoObjects.add(marker)
        map.geoObjects.add(newMapObj)
      })
      map.setBounds(map.geoObjects.getBounds(), { checkZoomRange: true, zoomMargin: 1 })
      geozoneLoaded = true
    }

    const init = async () => {
      if (map) return
      map = yMap.value
      ymaps = await loadYmaps()
      if (geozones.value && !geozoneLoaded) addGeozones()
    }

    watch(() => yMap.value, (val) => {
      if (val) init()
    })
    watch(() => geozones.value, (val) => {
      if (!val.length) return
      // если геозоны были отрисованы раньше и изменилось их количество - была добавлена/удалена геозона
      if (geozoneLoaded) {
        // удаление всех объектов с карты (в т.ч. техники)
        yMap.value.geoObjects.removeAll()
        // инициализация карты, добавление техники
        context.refs.geozoneMap.init()
      }
      // добавление геозон на карту
      addGeozones()
    })

    watch(() => address.value, (val) => {
      eventBus.$emit('update-location', val)
    })

    onUnmounted(() => {
      yMap.value.geoObjects.removeAll()
      yMap.value.destroy()
      $store.dispatch('geozones/clear')
    })

    return {
      init,
      yMap,
      geozones,
      address,
    }
  },
}
